<ng-content select="sh-stacked-layout-topbanner"></ng-content>
<div><ng-content select="sh-stacked-layout-appbar"></ng-content></div>
<div class="sh-stacked-layout-container">
	<ng-content select="sh-stacked-layout-content"></ng-content>
	<ng-content select="sh-stacked-layout-footer"></ng-content>
</div>
